angular.module('NumbersEditor').controller('PostDrawWeightController', [
    '$scope', '$routeParams', '$rootScope', 'EventFactory', '$filter', '$location', '$dialogs',
    function ($scope, $routeParams, $rootScope, eventFactory, $filter, $location, $dialogs) {

        function init() {
            $scope.SportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            eventFactory.GetEventExtraInfo($routeParams.eventId, 0)
                .success(function (data) {
                    $scope.EventExtraInfo = data;
                    $scope.SelectedBallSet = parseInt(data.SetOfBalls);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        function getSubTitle() {
            var sportCode = $routeParams.sportCode === "49" ? "49" : "Irish Lottery";
            var eventNo = parseInt($routeParams.no);
            var draw = "";
            if (sportCode === "49" && eventNo === 1)
                draw = "Lunch Time";
            else if (sportCode === "49" && eventNo === 2)
                draw = "Tea Time";
            var date = $filter("date")($routeParams.startDate, "fullDate");

            return sportCode + " - " + draw + " - (" + date + ")";
        }

        $rootScope.SetAppTitle("Post Draw Weight", getSubTitle());

        init();

        $scope.Save = function () {
            eventFactory.SaveEventExtraInfo($routeParams.eventId, $scope.EventExtraInfo)
                .success(function () {
                    $.message(MessageText.EventExtraInfoSuccessfullySaved, MessageType.Success);
                    $location.path("/postdrawcertificate/" + $routeParams.eventId);
                })
                .error(function (error) {
                    $.message(error.ExceptionMessage, MessageType.Error);
                });
        };

        $scope.GoToPublishResult = function () {
            $dialogs.confirm('Please Confirm', 'Changes will be lost, are you sure?')
                .result.then(function () {
                    $location.path("publishresults/" + $routeParams.eventId)
                        .search({
                            sportCode: $routeParams.sportCode,
                            startDate: $routeParams.startDate,
                            gameId: $routeParams.gameId,
                            no: $routeParams.no
                        });
                });
        };
    }
]);